import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const categoryApiService = createApi({
  reducerPath: "categoryApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getCategories: builder.query({
      query: (params) => ({ url: `category/get`, params }),
    }),
    getCategoryById: builder.query({
      query: (id) => `category/get/${id}`,
    }),
    getCreatorsByCategory: builder.query({
      query: (params) => ({
        url: `category/get/creator`,
        params,
      }),
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useGetCategoryByIdQuery,
  useGetCreatorsByCategoryQuery,
} = categoryApiService;
